import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData, fetchDataActive, fetchDatalist, fetchData1 } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { IconButton, Modal, Button, TextField, MenuItem } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import Select from 'react-select';
import {
  Search as SearchIcon,

  Edit as EditIcon,
  Delete as DeleteIcon
} from '@mui/icons-material';
import { TableCell, TableContainer, Tooltip, Paper, Table, TableHead, TableBody, TableRow } from '@mui/material';

const ClubEdit = () => {
  const { id } = useParams();
  const history = useHistory();
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isIdValid, setIsIdValid] = useState(true);
  const { isAuthenticated, clubId, branchId, userId, logout, token } = useAuth();
  const [filteredData, setFilteredData] = useState([]);
  const [data, setData] = useState([]);
  const [selectedMember, setSelectedMember] = useState(""); // Store selected member ID
  const [selectedUser, setSelectedUser] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [formData, setFormData] = useState({
    Name: '',
    gstNo: '',
    dateOfJoining: '',
    addressLine1: '',
    addressLine1: '',
    email: '',
    pincode: '',
    district: '',
    state: '',
    country: '',
    location: '',
  });




  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newRecordData, setNewRecordData] = useState({
    id: 0, // Default for new records
    MemberId: '',
    UserTypeId: '',
    Since: '',
    IsActive: ''
  });
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [ClubChildDatas, setClubChildDatas] = useState([]);

  useEffect(() => {
    const fetchTableData = async () => {
      try {
        const response = await fetchData('ClubApi', `/data/${id}`, token);

        if (response.responseCode === '1111') {
          // Destructure response data with fallbacks
          const clubdata = response.response_data.ClubData || {}; // Fallback to an empty object
          const clubchilddata = response.response_data.ClubChildData || []; // Fallback to an empty array

          // Set master data in form with updated user info
          setFormData({
            ...clubdata,
            UpdatedBy: userId,
          });

          // Set child data for the table
          setClubChildDatas(clubchilddata);

          // Optionally set filtered data if needed
          setFilteredData(response.response_data);
        } else {
          console.error('Unexpected response code:', response.responseCode);
        }
      } catch (error) {
        console.error('Error fetching Persons Details:', error);

        // Handle unauthorized access
        if (error.response && error.response.status === 401) {
          logout();
          history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
        }
      }
    };

    fetchTableData();
  }, [id, isAuthenticated, token, userId, logout]);



  const handleChange = (event) => {
    const { name, value, type } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? !prevData[name] : value,
    }));
  };



  const formatDateForInput = (dateString) => {
    if (!dateString) return ''; // Handle cases where dateString is undefined or null
    const currentDate = new Date(dateString);
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`; // Return in 'YYYY-MM-DD' format
  };



  const handleSubmit
    = async (e) => {
      e.preventDefault();

      const CreateData = {
        Id: formData.ID,
        Name: formData.Name || null,  // Pass null if lastname is falsy
        PhoneNumber: formData.PhoneNumber || null,  // Pass null if firstname is falsy
        Email: formData.Email || null,  // Null if weddinganniversary is falsy
        GSTNumber: formData.GSTNumber || null,  // Null if dateofjoining is falsy
        AddressLine1: formData.AddressLine1 || null,  // Null if dateofbirth is falsy
        AddressLine2: formData.AddressLine2 || null,  // Null if phonenumber is falsy
        City: formData.City || null,  // Null if email is falsy
        District: formData.District || null,  // Null if remark is falsy
        State: formData.State, // Null if userId is falsy (unlikely for userId)
        Country: formData.Country,  // Always generate the current date
        PinCode: formData.PinCode,
        IsActive: formData.IsActive,
        CreatedBy: formData.CreatedBy,
        UpdatedBy: userId,  // Null if gender is falsy
        JoiningDate: formData.JoiningDate, // Null if clubId is falsy
        CreatedDate: formData.CreatedDate, // Default to 4 (doesn't need a null check)
        UpdatedDate: new Date(),
        BillRemarks: formData.BillRemarks,
        ClubCode: formData.ClubCode,
        IsSuperAdmin: formData.IsSuperAdmin,
        ReprintPassword: formData.ReprintPassword,
        Location: formData.Location

      };

      const childdata = ClubChildDatas.map(childdata => ({
        Id: childdata.Id,
        ClubId: clubId,
        MemberId: childdata.MemberId,
        Since: childdata.Since || null,
        UserTypeId: childdata.UserTypeId || null,
        CreatedBy: childdata.Id === 0 ? userId : childdata.createdBy,  // Conditionally set CreatedBy
        CreatedDate: childdata.Id === 0 ? new Date() : childdata.createdDate,  // Conditionally set CreatedDate
        ModifiedBy: childdata.Id === 0 ? userId : childdata.ModifiedBy,
        ModifiedDate: childdata.Id === 0 ? new Date() : childdata.ModifiedDate,
        IsActive: true,

      }));

      const ClubAndChildView = {
        ClubData: CreateData,
        ClubChildData: childdata,
      };

      try {
        const response = await updateData('ClubApi', id, ClubAndChildView, token);
        console.log('Record updated successfully:', response);

        setTimeout(() => {
          setSuccessMessage("");
        }, 3000);

        history.push('/CIndex');

      } catch (error) {
        console.error('Error updating record:', error);
      }
    };

  //-------------------------------------------------------------------------------

  // Function to toggle modal for both adding and editing
  const toggleModal = (recorddata = null) => {
    if (recorddata && recorddata.MemberId !== null && recorddata.MemberId !== undefined) {
      // Open modal for editing an existing record
      setSelectedRecord(recorddata);
      setNewRecordData({
        UserTypeId: recorddata.UserTypeId,
        MemberId: recorddata.MemberId,
        Since: recorddata.Since,
        IsActive: recorddata.IsActive,
      });
    } else {
      // Open modal for adding a new record (when recorddata is null or MemberId is null)
      setSelectedRecord(null);
      setNewRecordData({ UserTypeId: '', MemberId: '', Since: '' }); // Ensure it's empty for adding new records
    }
    setIsModalOpen(true); // Open the modal
  };


  // Handle form input changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setNewRecordData({ ...newRecordData, [name]: value });
  };

  
  const addOrEditRecord = () => {
    // Check if MemberId already exists in another role (UserTypeId)
    const isMemberInAnotherRole = ClubChildDatas.some((data) => {
      // Ensure both MemberId and UserTypeId are strings (or both numbers) for a proper comparison
      const memberIdMatch = String(data.MemberId) === String(newRecordData.MemberId);
      // const userTypeIdMatch = String(data.UserTypeId) !== String(newRecordData.UserTypeId);

      // Return true if the MemberId matches but the UserTypeId is different
      return memberIdMatch; //&& userTypeIdMatch;
    });

    if (isMemberInAnotherRole) {
      // Optionally, show an error message or handle the case where the MemberId already exists in another role
      alert('This Member ID is already assigned to another role. Please select a different Member ID.');
      return; // Stop the function if the MemberId is in another role
    }

    // Check if we're editing an existing record
    if (selectedRecord) {
      setClubChildDatas(
        ClubChildDatas.map((data) =>
          data.Id === selectedRecord.Id ? { ...newRecordData, Id: selectedRecord.Id } : data
        )
      );
    } else {
      // Adding new record, set initial ID based on your logic
      const newId = ClubChildDatas.length > 0 ? Math.max(...ClubChildDatas.map(data => data.Id)) + 1 : 1; // Generate a new ID
      setClubChildDatas([...ClubChildDatas, { ...newRecordData, Id: newId }]);
    }

    setIsModalOpen(false); // Close the modal
  };

  useEffect(() => {
    fetchMember();
    fetchPositions();

  }, []);


  const [memberlist, setMemberOptions] = useState([]);
  const [positionlist, setPositionsOptions] = useState([]);

  const fetchMember = async () => {
    try {
      const params1 = `/${clubId}`;
      const params2 = `?branchId=${branchId}`;
     // const response = await fetchData1('MemberApi', params1, params2, token);
       const response = await fetchData1('MemberApi', `/${clubId}/${branchId}`, token);
      if (response.responseCode === '1111') {

        const options = response.response_data.map(member => ({
          value: member.id,
          label: member.firstName,

        }));
        setMemberOptions(options);
      }
    } catch (error) {
      console.error('Error fetching Member:', error);
    }
  };
  const handlePositionSelectChange = (selectedOption) => {
    setNewRecordData({ ...newRecordData, UserTypeId: selectedOption.value });
  };

  const handleMemberSelectChange = (selectedOption) => {
    setNewRecordData({ ...newRecordData, MemberId: selectedOption.value });
  };

  const handleDateChange = (event) => {
    setNewRecordData({ ...newRecordData, Since: event.target.value });
  };







  const fetchPositions = async () => {
    try {
      const response = await fetchData('UserTypesApi', `/${clubId}`, token)
      if (response.responseCode === '1111') {

        const options = response.response_data.map(usertypes => ({
          value: usertypes.Id,
          label: usertypes.Name,

        }));
        setPositionsOptions(options);
      }
    } catch (error) {
      console.error('Error fetching User Types:', error);
    }
  };



  return (
    <div className="w-full max-w-sm container mt-2 mx-auto">



      <form onSubmit={handleSubmit}>
        <div className="w-full mb-2 flex">
          <h6 className="productHead flex-grow linkcolor" style={{ color: 'black', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
            CLUB- EDIT
          </h6>
          <div className="button-container-2" style={{ marginRight: '10px' }}>
            {/* <Button
              onClick={handleSubmit}
              style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#EDC001' }}
              disabled={!isIdValid}
            >
              UPDATE
            </Button> */}
            <Button
              style={{
                backgroundColor: '#5DB996',
                color: 'white',
                height: '36px',
                marginTop: '15px'

              }}
              onClick={handleSubmit}
              className="linkcolor"
            >
              <span>Update</span>
            </Button>

          </div>
          <div className="button-container-3">
            <Button
              className="linkcolor"
              onClick={() => history.push('/CIndex')}

              style={{
                backgroundColor: '#FF748B',
                color: 'white',
                height: '36px',
                marginTop: '15px'

              }}>
              CANCEL
            </Button>
          </div>
        </div>

        {errorMessage && <p className="text-red-500">{errorMessage}</p>}
        {successMessage && <p className="text-green-500">{successMessage}</p>}

        <div className="w-full flex flex-wrap">


          <div className="w-full sm:w-3/5 p-6 bg-white rounded-lg">

            <div className="w-full grid grid-cols-3 gap-4">
              <div>
                <label htmlFor="name">Name</label>
                <input
                  className="border-2 border-#88b0d2-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:outline-none"
                        
                  name="Name"
                  value={formData.Name}
                  onChange={handleChange}
                  type="text"
                  placeholder="Enter Name"
                  disabled={!isIdValid}
                />
              </div>

              <div>
                <label htmlFor="Last Name">GST Number</label>
                <input
                   className="border-2 border-#88b0d2-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:outline-none"
                        
                  name="GSTNumber"
                  value={formData.GSTNumber}
                  onChange={handleChange}
                  type="text"
                  placeholder="Enter Last Name"
                  disabled={!isIdValid}
                />
              </div>

              <div>
                <label htmlFor="code">Date of Joining</label>
                <input
                   className="border-2 border-#234C6A-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:outline-none"
                        
                  name="JoiningDate"
                  value={formatDateForInput(formData.JoiningDate)}
                  onChange={handleChange}
                  type="date"
                  placeholder="Enter Joining Date"
                  disabled={!isIdValid}
                />
              </div>
            </div>
            <div className="w-full grid grid-cols-3 gap-4">

              <div>
                <label htmlFor="dateOfJoining">Address Line1</label>
                <input
                  className="border-2 border-#234C6A-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:outline-none"
                        
                  name="AddressLine1"
                  value={formData.AddressLine1}
                  onChange={handleChange}
                  type="text"
                  placeholder="Enter AddressLine1"
                  disabled={!isIdValid}
                />
              </div>

              <div>
                <label htmlFor="code">Address Line2</label>
                <input
                  className="border-2 border-#234C6A-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:outline-none"
                  name="AddressLine2"
                  value={formData.AddressLine2}
                  onChange={handleChange}
                  type="text"
                  placeholder="Enter AddressLine2"
                  disabled={!isIdValid}
                />
              </div>



              <div>
                <label htmlFor="code">Email</label>
                <input
                  className="border-2 border-#234C6A-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:outline-none"
                        
                  name="Email"
                  value={formData.Email}
                  onChange={handleChange}
                  type="text"
                  placeholder="Enter Email"
                  disabled={!isIdValid}
                />
              </div>
            </div>
            <div className="w-full grid grid-cols-3 gap-4">
              <div>
                <label htmlFor="code">Phone Number</label>
                <input
                   className="border-2 border-#234C6A-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:outline-none"
                        
                  name="PhoneNumber"
                  value={formData.PhoneNumber}
                  onChange={handleChange}
                  type="text"
                  placeholder="Enter Phone Number"
                  disabled={!isIdValid}
                />
              </div>

              <div>
                <label htmlFor="code">Pincode</label>
                <input
                   className="border-2 border-#234C6A-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:outline-none"
                        
                  name="PinCode"
                  value={formData.PinCode}
                  onChange={handleChange}
                  type="text"
                  placeholder="Enter PinCode"
                  disabled={!isIdValid}
                />
              </div>
              <div>
                <label htmlFor="code">District</label>
                <input
                 className="border-2 border-#234C6A-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:outline-none"
                        
                  name="District"
                  value={formData.District}
                  onChange={handleChange}
                  type="text"
                  placeholder="Enter District"
                  disabled={!isIdValid}
                />
              </div>


            </div>

            <div className="w-full grid grid-cols-3 gap-4">

              <div>
                <label htmlFor="code">State</label>
                <input
                   className="border-2 border-#234C6A-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:outline-none"
                        
                  name="State"
                  value={formData.State}
                  onChange={handleChange}
                  type="text"
                  placeholder="Enter State"
                  disabled={!isIdValid}
                />
              </div>
              <div>
                <label htmlFor="code">Country</label>
                <input
                  className="border-2 border-#234C6A-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:outline-none"
                        
                  name="Country"
                  value={formData.Country}
                  onChange={handleChange}
                  type="text"
                  placeholder="Enter Country"
                  disabled={!isIdValid}
                />

              </div>

              <div>
                <label htmlFor="code">Location</label>
                <input
                  className="border-2 border-#234C6A-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:outline-none"
                        
                  name="Location"
                  value={formData.Location}
                  onChange={handleChange}
                  type="text"
                  placeholder="Enter Location"
                  disabled={!isIdValid}
                />

              </div>
            </div>





          </div>

          <div className="w-full sm:w-2/5 pl-2">
            <div className='w-full mb-5 flex' style={{ maxHeight: '400px', overflowY: 'auto' }}>

              <TableContainer component={Paper}>
                <Table>
                  {/* Table Head */}
                  <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
                    <TableRow>
                      <TableCell colSpan={6} sx={{ borderBottom: '1px solid #ddd', textAlign: 'center', padding: '7px', fontSize: '16px', fontWeight: 'bold' }}>
                        CORE TEAM
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '7px' }}>Sl No</TableCell>
                      <TableCell sx={{ borderBottom: '1px solid #ddd' }}>Positions</TableCell>
                      <TableCell sx={{ borderBottom: '1px solid #ddd' }}>Member</TableCell>
                      <TableCell sx={{ borderBottom: '1px solid #ddd' }}>Since</TableCell>
                      <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center' }}>
                        <IconButton onClick={toggleModal} aria-label="add">
                          <AddIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  {/* Table Body */}
                  <TableBody>
                    {ClubChildDatas.map((childdata, index) => (
                      <TableRow key={index}>
                        {/* Serial Number */}
                        <TableCell sx={{ borderBottom: '1px solid #ddd' }}>{index + 1}</TableCell>

                        <TableCell sx={{ borderBottom: '1px solid #ddd' }}>
                          {positionlist.find((option) => option.value === childdata.UserTypeId)?.label}
                        </TableCell>


                        <TableCell sx={{ borderBottom: '1px solid #ddd' }}>
                          {memberlist.find((option) => option.value === childdata.MemberId)?.label}
                        </TableCell>



                        {/* Date of Birth */}
                        <TableCell sx={{ borderBottom: '1px solid #ddd' }}>
                          {formatDateForInput(childdata.Since)} {/* Ensure date formatting */}
                        </TableCell>


                        {/* Edit Icon */}
                        <TableCell sx={{ height: '40px', padding: '5px', textAlign: 'center' }}>
                          <IconButton onClick={() => toggleModal(childdata)}>
                            <EditIcon style={{ fontSize: '20px', color: 'blue' }} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>




            </div>
          </div>

          {/* Modal for Add/Edit */}
          {isModalOpen && (
            <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)}>
              <div className="fixed inset-0 flex items-center justify-center z-50">
                <div className="bg-white p-6 rounded-lg  w-full sm:w-1/2" style={{ maxHeight: '90vh', overflowY: 'auto' }}>
                  <div className="w-full mb-4 flex">

                    <div className="w-1/10 mr-2">
                      {selectedRecord && (
                        <div className="flex items-center mb-4">
                          <input
                            type="checkbox"
                            id="isActive"
                            checked={isActive}
                            onChange={(e) => setIsActive(e.target.checked)}
                            className="mr-2"
                          />
                          <label htmlFor="isActive">Active</label>
                        </div>
                      )}
                    </div>


                    <div className="w-1/10 mr-2">
                      <label htmlFor="position">Select Position</label>
                      <Select
                        value={positionlist.find(option => option.value === newRecordData.UserTypeId)}
                        onChange={handlePositionSelectChange}
                        options={positionlist}
                        placeholder="Search and select Position"
                        isSearchable
                      />
                    </div>

                    <div className="w-1/10 mr-2">
                      <label htmlFor="member">Select Member</label>
                      <Select
                        value={memberlist.find(option => option.value === newRecordData.MemberId)}
                        onChange={handleMemberSelectChange}
                        options={memberlist}
                        placeholder="Search and select member"
                        isSearchable
                      />
                    </div>

                    <div className="w-1/10 mr-2">
                      <label htmlFor="since">Since</label>
                      <input
                         className="border-2 border-#234C6A-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:outline-none"
                        
                        
                        type="date"
                        name="Since"
                        value={formatDateForInput(newRecordData.Since)} // Format the date for the input
                        onChange={handleDateChange} // Handle date change
                      />
                    </div>
                  </div>

                  <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: '16px' }}>
                    <Button
                      style={{ backgroundColor: '#22c55e', color: 'white', padding: '8px 16px', borderRadius: '4px' }}
                      onClick={addOrEditRecord}
                    >
                      {selectedRecord ? 'Edit Record' : 'Add Record'}
                    </Button>
                    <Button
                      style={{ backgroundColor: '#3b82f6', color: 'white', padding: '8px 16px', borderRadius: '4px', marginLeft: '8px' }}
                      onClick={() => setIsModalOpen(false)}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              </div>
            </Modal>
          )}

        </div>

      </form >
    </div >
  );
};

export default ClubEdit;
